// extracted by mini-css-extract-plugin
export default {"mainContainer":"increments-input_mainContainer__65HYK","buttonContainer":"increments-input_buttonContainer__Uhxoj","disable":"increments-input_disable__gGTw5"};